export const AI_AGENTS_PAGE_DESCRIPTION =
  'Manage generative AI calling, texting, email and chat services.';
export const AI_AGENTS_PAGE_NAME = 'AI Agents';
export const AI_STATUS_ACTIVE = 'active';
export const AI_STATUS_INACTIVE = 'inactive';
export const STATUS = {
  ON: 'ON',
  OFF: 'OFF'
};
export const TABS_TOOLTIP = {
  AI_LEASING: 'Settings to activate AI on leasing channels',
  AI_RESIDENT: 'Settings to activate AI on resident channels',
  GENERAL_SETTINGS: 'General settings to enable additional features',
  PRODUCTS:
    'This information represents AI products ordered by the property and does NOT enable or activate the actual product. Once toggled on, go to AI Leasing or AI Resident to activate the AI products.',
  RESPONSES: 'Add/edit Leasing & Resident response',
  SETUP: 'Additional features to simplify setup',
};
